import { MessageActionType } from "pubnub-redux";
import {
  APIPubNubMsgEvents,
  PubNubMessagePayload,
  RootAction,
  MessageHeaderActionType
} from "../../types";

export interface PubNubMsgState {
  byId: Record<string, MessageState>;
  showNewMessage: boolean;
}

const blankState = () => ({
  byId: {},
  showNewMessage: false,
  fireUnreadCount: false
});

export interface MessageState {
  newestMessageId?: string;
  newestConversationId?: string;
  messages?: PubNubMessagePayload[];
  newMessage?: boolean;
  readAt?: Date;
  conversationEnd?: boolean;
  fireUnreadCount?: boolean;
}

const pubNubMessageReducer = (state: State = blankState(), action: RootAction): State => {
  switch (action.type) {
    case MessageActionType.MESSAGE_RECEIVED: {
      if (!action || !action.payload || !action.payload.message || !action.payload.message.args)
        return state;

      const apiResponse = action.payload.message;
      const channel = action.payload.subscribedChannel;
      if (!apiResponse.event) return state;
      switch (apiResponse.event) {
        case APIPubNubMsgEvents.CONVERSATION_READ: {
          if (!apiResponse.args || !apiResponse.args.read_at) return state;
          const readAt = new Date(apiResponse.args.read_at);
          if (!readAt) return state;
          const newState = {
            byId: { ...state.byId },
            showNewMessage: state.showNewMessage
          };
          if (channel in newState.byId) {
            newState.byId[channel] = {
              ...newState.byId[channel],
              readAt: readAt,
              newMessage: false
            };
          } else {
            newState.byId[channel] = {
              readAt: readAt,
              newMessage: false
            };
          }
          return newState;
        }

        case APIPubNubMsgEvents.CONVERSATION_CREATED: {
          return state;
        }
        case APIPubNubMsgEvents.MESSAGE_ADDED: {
          if (!apiResponse.args || !apiResponse.args.message) return state;
          const messageId = apiResponse.args.message;
          const newestConversationId = apiResponse.conversation;

          const newState2 = {
            byId: { ...state.byId },
            showNewMessage: state.showNewMessage
          };
          if (channel in newState2.byId) {
            const messages =
              "messages" in newState2.byId[channel]
                ? newState2.byId[channel].messages.concat(action.payload)
                : [action.payload];
            const newMessage = newState2.byId[channel].newestMessageId !== messageId;
            newState2.showNewMessage = true;
            newState2.byId[channel] = {
              ...newState2.byId[channel],
              newestMessageId: messageId,
              newMessage,
              messages: messages,
              newestConversationId
            };
          } else {
            newState2.byId[channel] = {
              newestMessageId: messageId,
              newMessage: true,
              messages: [action.payload],
              newestConversationId
            };
            newState2.showNewMessage = true;
          }

          return newState2;
        }

        case APIPubNubMsgEvents.CONVERSATION_ENDED: {
          const newestConversationId = apiResponse.conversation;
          const newState3 = {
            byId: { ...state.byId },
            showNewMessage: state.showNewMessage
          };
          if (channel in newState3.byId) {
            newState3.byId[channel] = {
              ...newState3.byId[channel],
              conversationEnd: true,
              newestConversationId,
              newMessage: false
            };
          } else {
            newState3.byId[channel] = {
              conversationEnd: true,
              newMessage: false,
              newestConversationId
            };
          }
          return newState3;
        }
        default:
          return state;
      }
    }
    case MessageHeaderActionType.REMOVE_MESSAGE_BADGE:
      return {
        ...state,
        showNewMessage: false
      };
    case MessageHeaderActionType.ADD_MESSAGE_BADGE:
      return {
        ...state,
        showNewMessage: true
      };
    case MessageHeaderActionType.CONNECTED_EVENT: {
      const newStateConnected = {
        byId: { ...state.byId },
        showNewMessage: state.showNewMessage,
        fireUnreadCount: true
      };
      return newStateConnected;
    }
    default:
      return state;
  }
};
export default pubNubMessageReducer;
